<script setup>
// Titre de la bible. H1 et H2 : extra-gras encre, mot(s)-clé(s) en pastille qui se dessine (rose ou bleue, comme le flyer).
// H3 : mot-clé dans la couleur du ton, sans pastille. `keyword` accepte une chaîne ou un tableau.
// Usage : <BrandTitle as="h1" tone="maison" text="Des repas sains et personnalisés, livrés chez toi." :keyword="['sains', 'personnalisés']" />
import { computed } from 'vue';
import HighlightMark from './HighlightMark.vue';
import { TONES } from '../../lib/brandTones';

const props = defineProps({
  as: { type: String, default: 'h2' },
  tone: { type: String, default: 'maison' },
  text: { type: String, required: true },
  keyword: { type: [String, Array], default: '' },
  mark: { type: Boolean, default: undefined },
  align: { type: String, default: '' },
});
const useMark = computed(() => (props.mark === undefined ? props.as === 'h1' : props.mark));
const segments = computed(() => {
  const keys = (Array.isArray(props.keyword) ? props.keyword : [props.keyword]).filter(Boolean);
  const out = [];
  let rest = props.text;
  for (const key of keys) {
    const i = rest.indexOf(key);
    if (i < 0) continue;
    if (i > 0) out.push({ text: rest.slice(0, i), key: false });
    out.push({ text: key, key: true });
    rest = rest.slice(i + key.length);
  }
  if (rest) out.push({ text: rest, key: false });
  return out;
});
const sizeClass = computed(() => (props.as === 'h1'
  ? 'text-3xl md:text-5xl leading-[1.1]'
  : props.as === 'h3' ? 'text-lg md:text-xl' : 'text-2xl md:text-3xl'));
</script>

<template>
  <component :is="as" class="font-baloo font-extrabold text-[#111] text-balance" :class="[sizeClass, align]">
    <template v-for="(seg, i) in segments" :key="i"><HighlightMark v-if="seg.key && useMark" :tone="tone" :delay="150 + i * 120">{{ seg.text }}</HighlightMark><span v-else-if="seg.key" :class="TONES[tone].keyword">{{ seg.text }}</span><template v-else>{{ seg.text }}</template></template>
  </component>
</template>
